import React from 'react'
import styled from 'styled-components'
import { Box, Link, Text } from 'pcln-design-system'

const StyledLink = styled(Link)`
  color: ${(props) => props.disabled && 'text.light'};
  font-size: 14px;
  cursor: ${(props) => props.disabled && 'not-allowed'};
  &:hover {
    text-decoration: none;
  }
`

const SelectAllorNone = ({
  onSelectAllClick,
  onSelectNoneClick,
  isSelectAllDisabled,
  isSelectNoneDisabled,
}) => {
  return (
    <Box mb={2}>
      <StyledLink onClick={onSelectNoneClick} disabled={isSelectNoneDisabled}>
        Select None
      </StyledLink>
      <Text.span mx={2} color='text.light' fontSize={1}>
        |
      </Text.span>
      <StyledLink onClick={onSelectAllClick} disabled={isSelectAllDisabled}>
        Select All
      </StyledLink>
    </Box>
  )
}

export { SelectAllorNone }
